import Vue from 'vue'
import Router from 'vue-router'
import IntroView from '@/components/IntroView'
import MainView from '@/components/MainView'
import DashboardView from '@/components/DashboardView'
import HomeView from '@/components/HomeView'
import ErrorView from '@/components/ErrorView'
import EmployeesEditView from '@/components/EmployeesEditView'

Vue.use(Router)


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomeView',
      component: HomeView
    },
    {
      path: '/:otevurl',
      name: 'IntroView',
      component: IntroView
    },
    {
      path: '/:otevurl/appointment/start',
      name: 'MainView',
      component: MainView,
      props: true
    },
    {
      path: '/admin/dashboard',
      name: 'DashboardView',
      component: DashboardView,
      props: true
    },
    {
      path: '/admin/employees',
      name: 'EmployeesEditView',
      component: EmployeesEditView,
      props: true
    },
    {
      path: '/admin/401',
      name: 'ErrorView',
      component: ErrorView,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js